import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';
import { KC_MATERIAL_DATE_FORMATS } from 'src/app/Models/materialDatepickerConfig';
import { DmsService } from 'src/app/dms/dms.service';
import { Clients } from 'src/app/Models/clients';
import { MetaDataFields, TemplateUploadRequest, ClientGroups, DOCUMENT_TYPE_LIST, DocumentTypeId, DocumentAction, OFFICE_APP_MAPPINGS } from 'src/app/Models/dmsModel';
import { forkJoin, Subject, Subscription } from 'rxjs';
import { DocDefaultPreferenceEnum } from 'src/app/Models/SharePointPracticeModel';
import { CommonService } from 'src/app/shared/common.service';
import { takeUntil } from 'rxjs/operators';
import { UserManagementService } from 'src/app/shared/userManagement.service';

@Component({
  selector: 'app-dms-create-doc',
  templateUrl: './dms-create-doc.component.html',
  styleUrls: ['./dms-create-doc.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: KC_MATERIAL_DATE_FORMATS }, BsModalRef],
})

export class DmsCreateDocComponent implements OnInit {
  titletext: any = "Create document";
  btntxtCreateOpen: any = "Create and open";
  btntxtCreate: any = "Create";
  clientId: number;
  clients: any[];
  clientgroups: any[];
  filteredClients: any[];
  form: FormGroup;
  selectedClientGroups: any[] = [];
  folderId: any;
  paramClientId: any;
  folderLocation: any;
  currentFolderLocId: any;
  clientCode: any;
  mdlClientId: any;
  openWithList: any;

  // #region Metadata Declaration
  metaDataFields: any[];
  SiteId: number;
  formValuesArray: { SharepointSiteMetadataId: number, Value: any }[] = [];
  dropdownSettings1: { singleSelection: boolean; idField: string; textField: string; selectAllText: string; unSelectAllText: string; itemsShowLimit: number; allowSearchFilter: boolean; };
  maxDate: Date;
  // #endregion
  private subscription: Subscription;
  lastUsedRootFolderName: string | null = null;
  msg_FORBIDDEN_FILENAME_CHARS_PATTERN: string | null;
  msg_RESERVED_FILE_NAMES_PATTERN: string | null;
  unsubscribe = new Subject<void>();
  private timeoutId: any;
  documentTypeList = DOCUMENT_TYPE_LIST;
  documentType: number = DocumentTypeId.Merge; // Default to 'Create mail merge document'
  constructor(private localrouter: Router, public bsModalRef: BsModalRef, private modalService: BsModalService, private _dmsService: DmsService, private fb: FormBuilder, public datepipe: DatePipe, private toastr: ToastrService, private common: CommonService, private userManagementService: UserManagementService) {
  }

  @Output() outputParameter: EventEmitter<any> = new EventEmitter<any>();
  @Input() PopUpType: string;
  @Input() SourceFolderId: any;
  @Input() DocumentId: any;
  @Input() SiteType: string = "Client"

  ngOnInit() {
    this.msg_FORBIDDEN_FILENAME_CHARS_PATTERN = this._dmsService.MSG_FORBIDDEN_FILENAME_CHARS_PATTERN;
    this.msg_RESERVED_FILE_NAMES_PATTERN = this._dmsService.MSG_RESERVED_FILE_NAMES_PATTERN;
    this.callMultipleMethods();
    this.createForm();
    this.getOpwnWithList();
  }

  Caller() {
    this.subscription = this.common.sharedClientId$.pipe(takeUntil(this.unsubscribe)).subscribe(cid => {
      this.clientId = cid ?? 0;

      this.subscription = this.common.sharedFolderId$.pipe(takeUntil(this.unsubscribe)).subscribe(data => {
        this.folderId = data ?? '';
      });
    });

    if (this.folderId !== "Default Value" && this.folderId !== "") {
      this.getClientsByClientID(this.folderId);

      this.currentFolderLocId = this.folderId;
    }
    setTimeout(() => {
      if (this.clientId != null) {
        this.setclientGroupWithClientId();
      }
    }, 1000);

    this.dropdownSettings1 = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      itemsShowLimit: 2,
      allowSearchFilter: true
    };
  }

  callMultipleMethods(): void {
    // Using forkJoin to make multiple API calls in parallel
    forkJoin([
      this._dmsService.GetSPTemplates(),
      this._dmsService.GetClientGroupList(),
      this._dmsService.getClientListWithGroupCodes()
    ]).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (responses) => {
        const [spTemplatesResponse, clientGroupsResponse, clientListResponse] = responses;

        // Handling the response for GetSPTemplates
        if (spTemplatesResponse.success) {
          let lastSyncedDatetime = spTemplatesResponse.result.lastSyncedDatetime;
          this.templates = spTemplatesResponse.result.templates;
          if (this.templates?.length > 0) {
            this.showTemplatePopup = true;  // Flag to show template
          }
          else {
            this.showTemplatePopup = false;  // Flag to show template
            this.toastr.warning(spTemplatesResponse.message, "Sharepoint templates");
          }

        } else {
          this.toastr.info(spTemplatesResponse.message, "Sharepoint templates");
        }

        // Handling the response for GetClientGroupList
        if (clientGroupsResponse) {
          this.clientgroups = JSON.parse(clientGroupsResponse.httpResponse) as ClientGroups[];
        }

        // Handling the response for getClientListWithGroupCodes
        if (clientListResponse) {
          this.clients = JSON.parse(clientListResponse.httpResponse) as Clients[];
          if (this.selectedClientGroups.length > 0) {
            this.filteredClients = this.clients.filter(client =>
              this.selectedClientGroups.includes(client.GroupCode)
            );
          } else {
            this.filteredClients = [...this.clients];
          }
        }
        this.Caller();
      },
      error: (error) => {
        if (error.error.statusCode === 401) {
          this.localrouter.navigate(["/dms/auth"])
            .then(() => {
              this.closeModel();
            })
            .catch((error) => {
              this.toastr.error(error.error.message, 'Sharepoint Connection');
            });
        }
        else {
          this.toastr.error(error.error.message);
        }
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();

    if (this.subscription) {
      this.subscription.unsubscribe(); // Clean up subscription
    }
    // Prevent memory leaks if the component gets destroyed
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
  }

  closeModel(): void {
    this.clearDocumentList();
  }
  clearDocumentList() {
    //this.resetForm.emit();
    this.outputParameter.emit();
  }
  onSubmitCreateOpen(isDocPreviewtype: boolean = true): void {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }

    // #region Metadata fields
    this.formValuesArray = [];

    const uniqueIds = new Set<number>();

    const excludedKeys = ['Template', 'FileName', 'JobName', 'Clientgroup', 'Clientname', 'ClientCode', 'FolderLocation', 'Description', 'OpenWith', 'DocumentType'];

    for (const key in this.form.value) {
      if (this.form.value.hasOwnProperty(key)) {
        if (!excludedKeys.includes(key)) {
          const id = parseInt(key);
          const value = this.form.value[key];
          if (value !== null && value !== "") {
            if (!uniqueIds.has(id)) {
              uniqueIds.add(id);
              const fieldMeta = this.metaDataFields.find(field => field.SharepointSiteMetadataId === id);
              if (fieldMeta && fieldMeta.DataType === 'DATE') {
                const convertedDate = this.convertToDateFormat(this.datepipe.transform(value, 'dd/MM/yyyy'), "dynamic");
                this.formValuesArray.push({
                  SharepointSiteMetadataId: id,
                  Value: convertedDate
                });
              } else {
                this.formValuesArray.push({
                  SharepointSiteMetadataId: id,
                  Value: value
                });
              }
            }
          }
        }
      }
    }

    let metadataValues = this.formValuesArray.map(item => {
      if (Array.isArray(item.Value)) {
        return {
          ...item,
          Value: item.Value.join(',')
        };
      }
      return item;
    });

    const metadataValuesString = JSON.stringify(metadataValues);
    // #endregion

    // Set the correct file name with extension
    const fileName = this.form.controls['FileName'].value;
    const selectedTemplate = this.templates.find(t => t.id === this.selectedDriveItemID);
    const extension = selectedTemplate ? selectedTemplate.name.split('.').pop() : 'docx';

    if (!this.currentFolderLocId) {
      this.toastr.error("Please select folder location.");
      return;
    }

    const request: TemplateUploadRequest = {
      metadataValues: metadataValuesString,
      files: null,
      clientId: this.clientId,
      folderId: this.currentFolderLocId,
      siteId: 0,
      driveId: this.selectedDriveID,
      driveItemId: this.selectedDriveItemID,
      fileTemplateName: `${fileName}.${extension}`, // Ensure correct filename
      documentAction: this.getDocumentAction(this.form.controls['DocumentType'].value)
    };
    this._dmsService.uploadTemplate(request).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (response) => {
        this.toastr.info(response.message);
        if (isDocPreviewtype) {
          this.openCreatedDocument(response.httpResponse);
        }
        this.clearDocumentList();
      },
      error: (err) => {
        if (err.error && err.error.statusCode === 401) {
          this.toastr.info(`Reconnected to Microsoft SharePoint.`, 'SharePoint Connection');
        } else {
          let msg = err.error?.message || "An unexpected error occurred.";
          this.toastr.error(msg, 'Upload Failed');
        }
      }
    });
  }
  onSubmitCreate(): void {
    this.onSubmitCreateOpen(false);
  }
  getClientsByClientID(folderId: any) {
    this._dmsService.getClientsByClientID(folderId).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (res) {
        this.clientId = Number(res.httpResponse.clientId || 0);
      }
    });
    setTimeout(() => {
      this.setclientGroupWithClientId();
    }, 1000);
  }

  GetClientGroupList() {
    this._dmsService.GetClientGroupList().pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (res) {
        this.clientgroups = JSON.parse(res.httpResponse) as ClientGroups[];
      }
    });
  }
  selectedOption = []
  getClientList() {
    this._dmsService.getClientListWithGroupCodes().pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (res) {
        this.clients = JSON.parse(res.httpResponse) as Clients[];
        if (this.selectedClientGroups.length > 0) {
          this.filteredClients = this.clients.filter(client =>
            this.selectedClientGroups.includes(client.GroupCode)
          );
        } else {
          this.filteredClients = [...this.clients];
        }
      }
    });
  }

  // #region Folder Location
  openLocateFolderPopup(template) {
    const size: string = 'modal-lg';
    this.clientId = this.clientId ?? this.form.controls["Clientname"].value
    if (this.clientId) {
      this.bsModalRef = this.modalService.show(template, { class: `${size} modal-dialog-centered cmn-modal-dsgn m-auto`, backdrop: 'static' });
    } else {
      this.toastr.error("Please select client name to locate folder.")
    }
  }

  openLocateTemplatePopup(template) {
    const size: string = 'modal-lg';
    if (this.templates.length > 0) {
      this.bsModalRef = this.modalService.show(template, { class: `${size} modal-dialog-centered cmn-modal-dsgn m-auto`, backdrop: 'static' });
    } else {
      this.toastr.error("Please select template.")
    }
  }

  hidePopUp() {
    this.bsModalRef.hide();
  }

  clientRootFolderName: string = '';

  sendFolderLocation(folderLocation: any) {
    this.folderLocation = folderLocation?.locationPath ?? "";
    this.form.controls["FolderLocation"].setValue([this.folderLocation])
    // following is the parent folder or the actual source folder id where doc need to be created
    this.currentFolderLocId = folderLocation?.locationFolderId ?? "";
    this.clientRootFolderName = folderLocation.rootFolderName;
    // #region Metadata fields invoke
    this.SiteId = this.clients[0].SiteID;
    this.getMetaDataChild(this.SiteId);
    this.getMetaDataFields();
    // #endregion
    this.bsModalRef.hide();
  }
  // #endregion

  onSelectClientgroups(event: any) {
    this.form.controls["FolderLocation"].reset();
    this.form.controls["Clientname"].reset();
    this.currentFolderLocId = '';
    this.getClientList();
    this.clientCode = null;
    setTimeout(() => {
      this.clients = this.clients.filter(client => (client.GroupCode === event.GroupCode))
    }, 1000);
  }
  onSelectClientname(event: any) {
    this.clientCode = null;
    this.currentFolderLocId = '';
    this.form.controls["FolderLocation"].reset();
    this.clientId = event.ClientId ?? 0;
    const selectedClient = this.clients.find(client => client.ClientId === event.ClientId);
    if (selectedClient) {
      this.clientCode = selectedClient.ClientCode;
    } else {
      this.clientCode = null; // or handle as per your application's logic
    }
  }

  // Combined validator for empty string and invalid characters
  createForm() {
    this.form = this.fb.group({
      DocumentType: [this.documentType, Validators.required],
      Template: [null, Validators.required],
      FileName: ['', [Validators.maxLength(500), this._dmsService.fileNameValidator(), this._dmsService.reservedFileNameValidator()]],
      JobName: [],
      Clientgroup: [''],
      Clientname: ['', Validators.required],
      ClientCode: [],
      FolderLocation: ['', Validators.required],
      Description: [],
      OpenWith: ['']
    });
  }
  onSubmit() {
  }

  setclientGroupWithClientId() {
    if (this.clientId) {
      const clientItem = this.clients.find(client => client.ClientId === Number(this.clientId));

      if (clientItem) {
        this.mdlClientId = clientItem.ClientId;
        this.clientCode = clientItem.ClientCode;
        this.form.patchValue({
          Clientname: this.mdlClientId
        });
        if (!clientItem.GroupCode) {

        } else {
          const clientGroupItem = this.clientgroups.find(group => group.GroupCode === clientItem.GroupCode);

          if (clientGroupItem) {
            // Perform some action when clientGroupItem is found
            let mdlgroupcode = clientGroupItem.GroupCode;
            this.form.patchValue({
              Clientgroup: mdlgroupcode,
            });
          }
        }
      }
    }
  }

  preventInput(event: KeyboardEvent): void {
    event.preventDefault(); // Prevents any key input
  }

  getUserMetadataConfigPermission(): boolean {
    return localStorage.getItem('userMetadataPermission') == "true";
  }

  getMetaDataFields() {
    this.SiteId = this.clients[0].SiteID;

    // Avoid API call if root folder name hasn't changed
    if (this.clientRootFolderName === this.lastUsedRootFolderName) {
      return; // skip
    }

    this._dmsService.getMetaDataFields(this.SiteId).pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (res: any) => {
        const isUserMetadataConfigEnabled = this.getUserMetadataConfigPermission();
        const metdataFields = JSON.parse(res.httpResponse) as MetaDataFields[];
        if(isUserMetadataConfigEnabled) {
          this.getUserConfiguredMetadataValues(metdataFields);
        } else {
          this.handleMetadataFieldsMapping(metdataFields);
        }
      },
      error: (error: any) => {
        this.toastr.error('Error fetching metadata fields:', error);
      }
    });
  }

  getUserConfiguredMetadataValues(metadataFieldsResponse: any) {
    this.userManagementService.getUserMetadataConfig().pipe(takeUntil(this.unsubscribe)).subscribe({
      next: (response: any) => {
        if(response?.length) {
          this.handleUseMetadataConfigResponse(response, metadataFieldsResponse);
        } else {
          // No user configured metadata found - fallback to normal metadata
          this.handleMetadataFieldsMapping(metadataFieldsResponse);
        }
      },
      error: (error: any) => {
        this.toastr.error('Failed to fetch user configured metadata.');
        // API failure - fallback to normal metadata but ensure folder location is set
        this.handleMetadataFieldsMapping(metadataFieldsResponse);
      }
    });
  }

  handleUseMetadataConfigResponse(userConfiguredMetadata: any, metadataFieldsResponse: any) {
    // Validate inputs
    if (!userConfiguredMetadata?.length || !metadataFieldsResponse?.length) {
      this.handleMetadataFieldsMapping(metadataFieldsResponse);
      return;
    }

    // Create a map of user-configured metadata indexed by metadataId for quick lookup
    const userConfigMap = new Map();
    userConfiguredMetadata?.forEach((userConfig: any) => {
      userConfigMap.set(userConfig.metadataId, userConfig);
    });

    // Merge user-configured metadata with base metadata fields
    const mergedMetadataFields = metadataFieldsResponse?.map((baseField: any) => {
      const userConfig = userConfigMap.get(baseField.SharepointSiteMetadataId);
      
      // If user config exists, merge the defaultValue; otherwise use base field
      if (userConfig && userConfig?.defaultValue) {
        return {
          ...baseField,
          DefaultValue: userConfig.defaultValue
        };
      }
      
      return baseField;
    });

    this.metaDataFields = mergedMetadataFields || [];

    // Process metadata fields mapping with merged data (including user default values)
    this.metaDataFields.forEach(field => {
      let controlValue: any;
      
      if (field.DataType === 'CHOICE') {
        field.choiceArray = field?.ChoiceValues ? field?.ChoiceValues?.split(',') : [];

        // Check if user has configured default value for this field
        const defaultValue = field?.DefaultValue;
        let controlValues: string[] = [];

        if(this.clientRootFolderName && field.IsDefaultRootFolder) {
          const matchedValue = field.choiceArray.find((c: string) => c?.trim()?.toLowerCase() === this.clientRootFolderName?.trim()?.toLowerCase());
          // If selected Folder location Folder name is available in choice array selects it as default value in metadata dropdown else use user-configured default value.
          if(matchedValue) {
            controlValues = [matchedValue];
          } else if (defaultValue) {
            const defaultValues = Array.isArray(defaultValue) 
              ? defaultValue 
              : (typeof defaultValue === 'string' ? defaultValue?.split(',') : [defaultValue]).map((v: any) => v?.toString()?.trim());
            
            controlValues = defaultValues
              .map((val: string) => field?.choiceArray?.find((c: string) => c?.trim()?.toLowerCase() === val?.toLowerCase()))
              .filter((val: string) => val);
          } else {
            controlValues = [];
          }
        } else if (defaultValue) {
          // Fallback: use user-configured default value
          const defaultValues = Array.isArray(defaultValue) 
            ? defaultValue 
            : (typeof defaultValue === 'string' ? defaultValue?.split(',') : [defaultValue]).map((v: any) => v?.toString()?.trim());
          
          controlValues = defaultValues
            .map((val: string) => field?.choiceArray?.find((c: string) => c?.trim()?.toLowerCase() === val?.toLowerCase()))
            .filter((val: string) => val);
        }

        if (controlValues?.length > 0) {
          this.form.patchValue({ [field?.SharepointSiteMetadataId?.toString()]: controlValues });
        }
        controlValue = controlValues;
      } else if (field.DataType === 'DATE' && field?.DefaultValue) {
        controlValue = new Date(field.DefaultValue);
      } else if (field.DataType === 'YESNO' && field?.DefaultValue) {
        controlValue = (field.DefaultValue === 'true' || field.DefaultValue === true) ? 'true' : 'false';
      } else if (field.DataType === 'TEXT' && field?.DefaultValue) {
        controlValue = field.DefaultValue;
      } else {
        controlValue = null;
      }

      this.form.addControl(field.SharepointSiteMetadataId, this.fb.control(controlValue, field.Mandate ? Validators.required : null));
    });

    this.applyInitialChoiceDependencies();

    // Update tracker
    this.lastUsedRootFolderName = this.clientRootFolderName;
  }

  handleMetadataFieldsMapping(metadataFieldsResponse: any) {
    this.metaDataFields = metadataFieldsResponse || [];
    this.metaDataFields.forEach(field => {
      let controlValue;
      if (field.DataType === 'CHOICE') {
        field.choiceArray = field.ChoiceValues ? field.ChoiceValues.split(',') : [];

        const matchedValue = field.IsDefaultRootFolder
          ? field.choiceArray.find(c => c?.trim()?.toLowerCase() === this.clientRootFolderName?.trim()?.toLowerCase())
          : null;

        controlValue = matchedValue ? [matchedValue] : [];
        if(matchedValue) {
          this.form.patchValue({ [field?.SharepointSiteMetadataId?.toString()]: controlValue });
        }
      } else {
        controlValue = null;
      }

      this.form.addControl(field.SharepointSiteMetadataId, this.fb.control(controlValue, field.Mandate ? Validators.required : null));
    });

    this.applyInitialChoiceDependencies();

    // Update tracker
    this.lastUsedRootFolderName = this.clientRootFolderName;
  }


  onItemSelect(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event);

    if (!this.metadataDependencyMappings || this.metadataDependencyMappings.length === 0) {
      return;
    }

    if (field.DataType === 'CHOICE') {
      const selectedValues = this.form.get(field.SharepointSiteMetadataId.toString())?.value || [];

      // Find all relevant child mappings based on all selected main values
      const matchedMappings = this.metadataDependencyMappings.filter(dep =>
        dep.ParentMetadataId === field.SharepointSiteMetadataId &&
        selectedValues.some(val => dep.ParentChoiceValue.trim().toLowerCase() === val.trim().toLowerCase())
      );

      if (matchedMappings.length === 0) {
        // Clear all relevant child fields if no mappings found
        const childFields = this.metaDataFields.filter(f =>
          this.metadataDependencyMappings.some(m =>
            m.ParentMetadataId === field.SharepointSiteMetadataId &&
            m.ChildMetadataId === f.SharepointSiteMetadataId
          )
        );

        childFields.forEach(child => {
          child.choiceArray = null;
          const control = this.form.get(child.SharepointSiteMetadataId.toString());
          if (control) {
            control.setValue(null);
          }
        });

        return;
      }

      // Group mappings by child metadata ID and collect unique child choices
      const childChoiceMap = new Map<number, Set<string>>();

      matchedMappings.forEach(dep => {
        const childId = dep.ChildMetadataId;
        const childValues = dep.ChildChoiceValue ? dep.ChildChoiceValue.split(',').map(v => v.trim()) : [];

        if (!childChoiceMap.has(childId)) {
          childChoiceMap.set(childId, new Set());
        }

        childValues.forEach(val => childChoiceMap.get(childId)!.add(val));
      });

      // Update child fields with combined child values
      childChoiceMap.forEach((choices, childId) => {
        const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === childId);
        if (childField) {
          childField.choiceArray = Array.from(choices);
        }
      });
    }
  }

  onSelectAll(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event);
  }

  onDeSelect(event: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, event, true);
    this.onItemSelect(event, field);
    this.updateChildChoices(field); // refresh child based on remaining parents
  }

  onItemDeSelectAll(field: MetaDataFields) {
    this.removeFormValuesArray(field.SharepointSiteMetadataId);
    this.clearAllChildChoices(field);
  }

  onDateChange(date: any, field: MetaDataFields) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, date);
  }

  onYesNoChange(event: any, field: MetaDataFields, value: string) {
    this.updateFormValuesArray(field.SharepointSiteMetadataId, value);
  }

  updateFormValuesArray(id: number, value: any, remove: boolean = false) {
    const index = this.formValuesArray.findIndex(item => item.SharepointSiteMetadataId === id);
    if (remove) {
      if (index !== -1) {
        this.formValuesArray.splice(index, 1);
      }
    } else {
      if (index !== -1) {
        this.formValuesArray[index].Value = value;
      } else {
        this.formValuesArray.push({ SharepointSiteMetadataId: id, Value: value });
      }
    }
  }

  removeFormValuesArray(id: number) {
    const index = this.formValuesArray.findIndex(item => item.SharepointSiteMetadataId === id);
    if (index !== -1) {
      this.formValuesArray.splice(index, 1);
    }
  }

  isFieldInvalid(field: string): boolean {
    const control = this.form.get(field);
    return control?.invalid && (control.dirty || control.touched);
  }

  convertToDateFormat(dateString: string, type: string = "static"): string {
    const regex = /^(\d{2})[-\/](\d{2})[-\/](\d{4})$/;
    const match = dateString.match(regex);
    if (match && type === "static") {
      const day = match[1];
      const month = match[2];
      const year = match[3];
      return `${year}/${month}/${day}`;
    } else if (match && type === "dynamic") {
      const day = match[1];
      const month = match[2];
      const year = match[3];
      return `${year}/${month}/${day}`;
    }
    const date = new Date(dateString);
    if (!isNaN(date.getTime()) && type === "static") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    } else if (type === "dynamic") {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}/${month}/${day}`;
    }
    return '';
  }

  templates: any[] = [];
  selectedTemplateName: string = ''; // Stores selected template's name
  showTemplatePopup: boolean = false;

  loadSPTemplates() {
    this._dmsService.GetSPTemplates().pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      if (res.success) {
        this.templates = res.result;
        this.showTemplatePopup = true; // flag that triggers *ngIf to show template
      }
      else {
        this.toastr.info(res.message, "Sharepoint templates");
      }
    });
  }

  getImageForFile(fileName: string): string {
    return this._dmsService.getImageForFile(fileName);
  }

  selectedDriveID: string = '';
  selectedDriveItemID: string = '';
  selectedModifiedFileName: string = '';

  onTemplateSelect(templateId: any) {
    this.hidePopUp();
    this.selectedTemplateName = '';
    this.form.controls['FileName'].setValue('');
    // Find the template using the correct ID
    const selectedTemplate = this.templates.find(t => t.id === templateId.id);

    if (selectedTemplate) {
      this.form.controls["Template"].setValue(selectedTemplate.parentPath);
      this.form.controls['FileName'].setValue(selectedTemplate.nameWithoutExtention);
      this.selectedDriveID = selectedTemplate.driveId;
      this.selectedDriveItemID = selectedTemplate.id;
      this.selectedTemplateName = selectedTemplate.name; // Store full name (with extension) for icon display
      this.selectedModifiedFileName = this.form.controls['FileName'].value;
      this.getTemplatePreviewURL(selectedTemplate.driveId, selectedTemplate.id, null);
    }
  }

  previewUrl: string = ''; // Store the preview URL

  getTemplatePreviewURL(driveId: any, driveItemId: any, customURL: any) {
    if (customURL) {
      this.previewUrl = customURL;
    }
    else {
      this._dmsService.getPreviewURL(driveId, driveItemId).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
        if (res && res.getUrl) {
          this.previewUrl = res.getUrl;
        } else {
          this.previewUrl = ''; // Reset if no URL is returned
        }
      });
    }
  }

  getOpwnWithList() {
    this.openWithList = Object.keys(DocDefaultPreferenceEnum)
      .filter(key => isNaN(Number(key))) // Filter out numeric keys
      .map(key => ({
        Id: DocDefaultPreferenceEnum[key], // Enum value as Id
        name: key,           // Enum key as name
      }));
  }

  defaultDocURL: number = 2;

  onChangeOpenWith(event: any) {
    this.defaultDocURL = event.Id;
  }

  metadataDependencyMappings: any = [];
  getMetaDataChild(siteId: number) {
    this._dmsService.getMetadataDependencyMappings(siteId).pipe(takeUntil(this.unsubscribe)).subscribe((res: any) => {
      this.metadataDependencyMappings = JSON.parse(res.httpResponse); // Save in component
      this.applyInitialChoiceDependencies();
    });
  }

  private applyInitialChoiceDependencies() {
    if (!this.metaDataFields?.length || !this.metadataDependencyMappings?.length) {
      return;
    }

    this.metaDataFields
      .filter(field => field?.DataType === 'CHOICE')
      .forEach(field => {
        const selectedValues = this.form.get(field.SharepointSiteMetadataId.toString())?.value;
        if (Array.isArray(selectedValues) && selectedValues.length) {
          this.onItemSelect(selectedValues[0], field);
        }
      });
  }

  updateChildChoices(parentField: MetaDataFields) {
    if (!this.metadataDependencyMappings?.length) return;

    const selectedValues = this.form.get(parentField.SharepointSiteMetadataId.toString())?.value || [];

    // Find all mappings where ParentMetadataId matches
    const matchedMappings = this.metadataDependencyMappings.filter(
      dep =>
        dep.ParentMetadataId === parentField.SharepointSiteMetadataId &&
        selectedValues.includes(dep.ParentChoiceValue.trim())
    );

    // Map of ChildMetadataId → combined child values (from all selected parents)
    const childChoiceMap = new Map<number, Set<string>>();

    matchedMappings.forEach(dep => {
      const childId = dep.ChildMetadataId;
      const childValues = dep.ChildChoiceValue?.split(',').map(v => v.trim()) || [];
      if (!childChoiceMap.has(childId)) {
        childChoiceMap.set(childId, new Set());
      }
      childValues.forEach(val => childChoiceMap.get(childId)!.add(val));
    });

    // Update each child field dropdown and cleanup invalid selected values
    childChoiceMap.forEach((choices, childId) => {
      const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === childId);
      if (!childField) return;

      // Update available dropdown options
      childField.choiceArray = Array.from(choices);

      // Clean existing selected values if any are no longer valid
      const control = this.form.get(childId.toString());
      if (control) {
        let currentValues = control.value || [];
        if (!Array.isArray(currentValues)) currentValues = [currentValues];

        const validValues = currentValues.filter((val: string) => choices.has(val));
        if (validValues.length !== currentValues.length) {
          control.setValue(validValues.length > 0 ? validValues : null);
        }
      }
    });
  }

  clearAllChildChoices(parentField: MetaDataFields, visited: Set<number> = new Set()) {
    if (!this.metadataDependencyMappings?.length) return;

    // Prevent recursion loops
    if (visited.has(parentField.SharepointSiteMetadataId)) return;
    visited.add(parentField.SharepointSiteMetadataId);

    const childMappings = this.metadataDependencyMappings.filter(
      dep => dep.ParentMetadataId === parentField.SharepointSiteMetadataId
    );

    childMappings.forEach(dep => {
      const childField = this.metaDataFields.find(f => f.SharepointSiteMetadataId === dep.ChildMetadataId);
      if (!childField) return;

      // Clear dropdown and value
      childField.choiceArray = null;
      const control = this.form.get(childField.SharepointSiteMetadataId.toString());
      if (control) control.setValue(null);
      this.removeFormValuesArray(childField.SharepointSiteMetadataId);

      // Recurse further down to grandchildren
      this.clearAllChildChoices(childField, visited);
    });
  }

  getDocumentAction(documentTypeId: number): DocumentAction {
    return documentTypeId === DocumentTypeId.Merge ? DocumentAction.Merge : DocumentAction.Copy;
  }

  openCreatedDocument(httpResponse: any): void {
    switch (this.defaultDocURL) {
      case 1:
        this.getPreviewURL(httpResponse.spDriveItemId, httpResponse.spItemId);
        break;

      case 2:
        if (httpResponse.url) {
          window.open(httpResponse.url, '_blank');
        }
        this.clearDocumentList();
        break;

      case 3:
        this.openDesktopApp(httpResponse.spDriveItemId, httpResponse.spItemId);
        break;

      default:
        this.clearDocumentList();
        break;
    }
  }

  getPreviewURL(driveId: any, driveItemId: any) {
    this._dmsService.getPreviewURL(driveId, driveItemId).subscribe((res: any) => {
      window.open(res.getUrl, '_blank');
      this.clearDocumentList();
    });
  }

  openDesktopApp(driveId: any, driveItemId: any) {
    this._dmsService.OpenDesktopApp(driveId, driveItemId).subscribe((res: any) => {
      const officeUri = this.openInApp(res.webUrl);
      window.open(officeUri, '_blank');
      this.clearDocumentList();
    });
  }

  openInApp(sharePointDocumentUrl: string): string {
    const mapping = OFFICE_APP_MAPPINGS.find(item =>
      item.extensions.some(extension =>
        sharePointDocumentUrl.toLowerCase().endsWith(extension)
      )
    );

    if (mapping) {
      return `${mapping.protocol}${sharePointDocumentUrl}`;
    }

    this.toastr.error('File type is not supported for opening in Office apps.');
    return '';
  }
}
